import axios from "axios";
import { baseAPI, notConnectedMessage } from "../components/constants";

export class ClientTypeService {
    static url = `${baseAPI}/clientType`;

    static async createClientType(data: any) {
        try {
            const response = await axios.post(
                ClientTypeService.url + "/create",
                data,
                {
                    withCredentials: true,
                }
            );
            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async getClientType(page = 1, limit = 20, filter = {}) {
        try {
            const response = await axios.get(
                ClientTypeService.url + "/get-All",
                {
                    params: { page, limit, ...filter },
                    withCredentials: true,
                }
            );

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async updateClientType(id: number, data: any) {
        try {
            const response = await axios.patch(
                ClientTypeService.url + "/",
                data,
                {
                    params: { id: id },
                    withCredentials: true,
                }
            );

            return [response.data, null];
        } catch (error: any) {
            console.log(error);

            return [
                null,
                error.response?.data?.messaggeg || notConnectedMessage,
            ];
        }
    }

    static async deleteClientType(id: number) {
        try {
            const response = await axios.delete(ClientTypeService.url, {
                params: { id: id },
                withCredentials: true,
            });

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }
}
